import React from 'react';
import { FaFileCsv, FaFileExcel, FaFilePdf, FaFileImage, FaFileAlt, FaFile } from 'react-icons/fa';
import { FaFileZipper } from 'react-icons/fa6';
import { TbFileTypeXml } from 'react-icons/tb';

const DEFAULT_ICON_STYLE = { fontSize: '24px', marginRight: '12px' };

function formatKey(fileFormatOrName) {
  const raw = String(fileFormatOrName || '').trim().toLowerCase();
  if (!raw) return '';
  return raw.includes('.') ? raw.split('.').pop() : raw;
}

/** Same icons as /upload_batches — pass fileFormat or a filename. */
export function getUploadBatchFileIcon(fileFormatOrName, iconStyle = DEFAULT_ICON_STYLE) {
  switch (formatKey(fileFormatOrName)) {
    case 'csv':
      return <FaFileCsv style={{ ...iconStyle, color: '#52c41a' }} />;
    case 'xlsx':
    case 'xls':
    case 'excel':
      return <FaFileExcel style={{ ...iconStyle, color: '#52c41a' }} />;
    case 'pdf':
      return <FaFilePdf style={{ ...iconStyle, color: '#f5222d' }} />;
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
    case 'image':
      return <FaFileImage style={{ ...iconStyle, color: '#722ed1' }} />;
    case 'txt':
    case 'json':
    case 'text':
      return <FaFileAlt style={{ ...iconStyle, color: '#8c8c8c' }} />;
    case 'xml':
      return <TbFileTypeXml style={{ ...iconStyle, color: '#fa8c16' }} />;
    case 'zip':
      return <FaFileZipper style={{ ...iconStyle, color: '#1890ff' }} />;
    default:
      return <FaFile style={{ ...iconStyle, color: '#8c8c8c' }} />;
  }
}
